import { Component, h } from 'preact';

import Story from './Story';

const PRIMARY_GUTEN_TAG = process.env.primary_guten_tag;
const RELATED_CONTENT_URL = `https://www.texastribune.org/api/v1/content/?content_type=story,audio,video,pointer&tag=${PRIMARY_GUTEN_TAG}&tag!=object-tribcast&fields=id,url,readable_pub_date,headline,short_summary,lead_art&limit=4&format=json`;

class RelatedContent extends Component {
  constructor() {
    super();

    this.state = {
      stories: [],
    };
  }

  componentDidMount() {
    fetch(RELATED_CONTENT_URL)
      .then(res => res.json())
      .then(({ results: stories }) => this.setState({ stories }));
  }

  render({ title }, { stories }) {
    return (
      <section class="related-stories">
        {title && <h3 class="subhead">{title}</h3>}
        <nav class="stories">
          {stories.map(story => <Story key={story.id} {...story} />)}
        </nav>
      </section>
    );
  }
}

export default RelatedContent;



// WEBPACK FOOTER //
// ./components/RelatedContent.js